import { getAuth } from 'firebase/auth'
import moment from 'moment'
import React, { FormEvent, FunctionComponent, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Product } from '../../../pages/DashBoard/DashBoardScreen'
import requestActions from '../../../redux/requests/requestActions'
import { BackButton } from '../../molecules/BackButton/BackButton'
import * as S from './styled'
import { ReactComponent as ShippingCostIcon } from '../../atoms/Icons/shipping-cost.svg'
import config from '../../../configurations'
import * as Validation from '../../molecules/Validation/ValidationForManualDoc'
import { ReactComponent as DropDownArrowIcon } from '../../atoms/Icons/DropDownArrow.svg'
import { useHistory } from 'react-router'
type OwnProps = {}

export const eggArrayFirstPart = [
  {
    key: 'Packeri',
    agriKey: 'buyer',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
  {
    key: 'Leverantörs nr.',
    agriKey: 'supplierId',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
  {
    key: 'Avräkningsdatum',
    agriKey: 'settlementDate',
    icon: <ShippingCostIcon />,
    type: 'date',
  },
  {
    key: 'Vecka',
    agriKey: 'week',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
  {
    key: 'Levnadsvecka hönor',
    agriKey: 'hensLifeWeek',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
  {
    key: 'Avdelning',
    agriKey: 'houseId',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
  {
    key: 'Genomsnittligt-pris/kg SEK',
    agriKey: 'avgPricePerKg',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
  {
    key: 'Medelvikt g',
    agriKey: 'avgWeight',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
  {
    key: 'Pris per styck SEK',
    agriKey: 'avgPrice',
    icon: <ShippingCostIcon />,
    type: 'text',
  },
]

export const eggArraySecondPart = [
  {
    key: 'Frigående ägg XL',
    agriKey: 'freeRangeEgg_XL',
  },
  {
    key: 'Frigående ägg L',
    agriKey: 'freeRangeEgg_L',
  },
  {
    key: 'Frigående ägg M',
    agriKey: 'freeRangeEgg_M',
  },
  {
    key: 'Frigående ägg S',
    agriKey: 'freeRangeEgg_S',
  },
  {
    key: 'Frigående sekunda ägg ',
    agriKey: 'secondClass',
  },
  {
    key: 'Frigående smutsägg ',
    agriKey: 'dirty',
  },
  {
    key: 'Frigående knäckägg ',
    agriKey: 'broken',
  },
  {
    key: 'Frigående odugliga ägg ',
    agriKey: 'unacceptable',
  },
  {
    key: 'Frigående inomhus Särpack ',
    agriKey: 'kgs_separately_packed',
  },
  {
    key: 'Frånsorterat / XS',
    agriKey: 'separatelyPacked',
  },
]

type Props = OwnProps

export const CreateEggDocument: FunctionComponent<Props> = () => {
  const [showDetails, setShowDetails] = useState(false)
  const auth = getAuth()
  const user = auth.currentUser
  const dispatch = useDispatch()
  const history = useHistory()
  let isValid = false
  function submitHandler(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault()

    const labelsAndInputs = Validation.getLabelAndInputElements(
      event.currentTarget.children[0].children,
    )
    isValid = Validation.validateInput(
      labelsAndInputs[0] as HTMLLabelElement[],
      labelsAndInputs[1] as HTMLInputElement[],
      'eggs',
    )
    if (isValid) {
      es.uploadedBy = user!.email
      es.date = moment(new Date()).format('YY-MM-DD HH:mm:ss')
      es.product = 'egg'
      es.fileName = es.buyer + es.settlementDate

      dispatch(requestActions.products.createDocument(es, Product.EGG, user!.uid))
      history.push('/documents')
    } else {
    }
  }
  const es: any = {}
  es.data = new Array(10)
  es.classATotalEggs = {}
  es.totalDiscarded = {}

  return (
    <S.Container>
      <BackButton />
      <form onSubmit={submitHandler}>
        <S.ParentDiv>
          {eggArrayFirstPart.map((ea, i) => {
            return (
              <S.ChildDiv key={i}>
                {ea.icon && <S.IconStyled>{ea.icon}</S.IconStyled>}
                <S.LabelStyled>{ea.key}</S.LabelStyled>
                <S.InputStyled
                  max={ea.agriKey === 'settlementDate' ? moment().format('YYYY-MM-DD') : ''}
                  type={ea.type}
                  onChange={e => {
                    es[ea.agriKey] = e.target.value
                    const newType =
                      ea.agriKey === 'buyer'
                        ? 'text'
                        : ea.agriKey === 'settlementDate'
                        ? 'date'
                        : 'number'
                    Validation.validateType(e.currentTarget.value, e.currentTarget, newType)
                  }}
                ></S.InputStyled>
              </S.ChildDiv>
            )
          })}
        </S.ParentDiv>
        <div>
          <S.Details onClick={() => setShowDetails(prevValue => !prevValue)}>
            {showDetails ? 'Visa mindre' : 'Klicka för att se fler fält'}
            <DropDownArrowIcon
              style={{
                height: '30px',
                alignItems: 'center',
                marginLeft: '0.5rem',
              }}
            />
          </S.Details>
          {showDetails && (
            <S.TableStyled>
              <thead>
                <tr>
                  <th>Äggtyp</th>
                  <th>Antal</th>
                  <th>%</th>
                  <th>Pris / st</th>
                  <th>Totalpris</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <S.TableDataStyled>
                    <S.NameBoxStyled
                      text={config.detailsConfig.classASummary.text}
                      bgColor={config.detailsConfig.classASummary.bgColor}
                      type={config.detailsConfig.classASummary.name}
                    />
                    Kvalitetsklass A Total
                  </S.TableDataStyled>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.classATotalEggs.amount = e.target.value
                      }}
                    />
                  </td>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.classATotalEggs.percentage = e.target.value
                      }}
                    />
                  </td>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.classATotalEggs.price = e.target.value
                      }}
                    />
                  </td>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.classATotalEggs.total = e.target.value
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <S.TableDataStyled>
                    <S.NameBoxStyled
                      text={config.detailsConfig.totalDiscarded.text}
                      bgColor={config.detailsConfig.totalDiscarded.bgColor}
                      type={config.detailsConfig.totalDiscarded.name}
                    />
                    Frånsorterad Total
                  </S.TableDataStyled>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.totalDiscarded.amount = e.target.value
                      }}
                    />
                  </td>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.totalDiscarded.percentage = e.target.value
                      }}
                    />
                  </td>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.totalDiscarded.price = e.target.value
                      }}
                    />
                  </td>
                  <td>
                    <S.InputTableStyled
                      type="text"
                      onChange={e => {
                        Validation.validateType(e.currentTarget.value, e.currentTarget, 'number')
                        es.totalDiscarded.total = e.target.value
                      }}
                    />
                  </td>
                </tr>

                {eggArraySecondPart.map((ea, i) => {
                  es.data[i] = { type: ea.agriKey }
                  return (
                    <tr key={i}>
                      <S.TableDataStyled>
                        <S.NameBoxStyled
                          text={config.detailsConfig[ea.agriKey].text}
                          bgColor={config.detailsConfig[ea.agriKey].bgColor}
                          type={config.detailsConfig[ea.agriKey].name}
                        />
                        {ea.key}
                      </S.TableDataStyled>
                      <td>
                        <S.InputTableStyled
                          type="text"
                          onChange={e => {
                            es.data[i].amount = e.target.value
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                          }}
                        />{' '}
                      </td>
                      <td>
                        <S.InputTableStyled
                          type="text"
                          onChange={e => {
                            es.data[i].percentage = e.target.value
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                          }}
                        />{' '}
                      </td>
                      <td>
                        <S.InputTableStyled
                          type="text"
                          onChange={e => {
                            es.data[i].price = e.target.value
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                          }}
                        />{' '}
                      </td>
                      <td>
                        <S.InputTableStyled
                          type="text"
                          onChange={e => {
                            es.data[i].totalPrice = e.target.value
                            Validation.validateType(
                              e.currentTarget.value,
                              e.currentTarget,
                              'number',
                            )
                          }}
                        />{' '}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </S.TableStyled>
          )}
        </div>
        <S.Button type="submit">Lägg Till</S.Button>
      </form>
    </S.Container>
  )
}

export default CreateEggDocument
